import styled from "styled-components";

import iconCheck from "../../assets/images/icon-check.svg";

const NewTodoWrapper = styled.form`
  grid-column: 2/3;
  grid-row: 3/4;

  color: var(--text);
  font-size: 2rem;
  padding: 1rem;

  background-color: var(--todo-BG);
  display: flex;
  gap: 2rem;
  align-items: center;
  padding: 1rem 4rem;
  border-radius: 4px;

  & .text-input {
    background-color: transparent;
    border: 0;
    color: var(--text);
    font-family: var(--font);
    font-size: 1.9rem;
    cursor: pointer;
    flex: 1;
    padding: 1rem;
    border-radius: 6px;

    &::placeholder {
      color: var(--text-light);
    }

    &:focus {
      border: 1px solid var(--bright-blue);
    }
  }

  & .check-input {
    appearance: none;
    width: 4rem;
    height: 4rem;
    border: 1px solid var(--text-light);
    background-color: transparent;
    border-radius: 50%;
    cursor: pointer;

    &:checked {
      background: url(${iconCheck}) no-repeat center, var(--check-background);
    }
    &:hover {
      border-color: var(--bright-blue);
    }
  }

  & label {
    cursor: pointer;
  }
`;

export default NewTodoWrapper;
